export const getRandomColor = (): string => {
  const h: number = Math.floor(Math.random() * 360); // 色相
  const s: number = Math.floor(Math.random() * 21) + 25; // 飽和度
  const l: number = Math.floor(Math.random() * 11) + 65; // 明度

  const hslToHex = (h: number, s: number, l: number): string => {
    const lPercent: number = l / 100;
    const a: number = (s * Math.min(lPercent, 1 - lPercent)) / 100;

    const f = (n: number): string => {
      const k: number = (n + h / 30) % 12;
      const color: number = lPercent - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`.toUpperCase();
  };

  return hslToHex(h, s, l);
};

const COLORS = [
  { name: "sky", color: "#0EA5E9", bgColor: "#E0F2FE" },
  { name: "indigo", color: "#6366F1", bgColor: "#E0E7FF" },
  { name: "orange", color: "#EA580C", bgColor: "#FEE2D5" },
  { name: "teal", color: "#14B8A6", bgColor: "#CCFBF1" },
  { name: "amber", color: "#F59E0B", bgColor: "#FEF3C7" },
  { name: "rose", color: "#F43F5E", bgColor: "#FFE4E6" },
  { name: "cyan", color: "#06B6D4", bgColor: "#CFFAFE" },
  { name: "green", color: "#22C55E", bgColor: "#DCFCE7" },
  { name: "pink", color: "#EC4899", bgColor: "#FCE7F3" },
  { name: "yellow", color: "#EAB308", bgColor: "#FEF9C3" },
  { name: "purple", color: "#8B5CF6", bgColor: "#EDE9FE" },
] as const;

export const getColor = (index: number) => COLORS[index % COLORS.length];
